const resources = [
  ['stats', '/dashboard'], ['cover', '/shifts?window=upcoming', 'shifts'],
  ['sites', '/locations', 'locations'], ['invoices', '/invoices', 'invoices'],
  ['hours', '/shifts?window=recent', 'shifts'], ['terms', '/terms/current'],
];

// A failed read is unavailable, not an empty list or an accepted legal state.
export async function readClientHub(api, token, fetchImpl = fetch) {
  const results = await Promise.allSettled(resources.map(async ([key, path, list]) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);
    try {
      const response = await fetchImpl(`${api}/client-hub${path}`, { headers: { Authorization: `Bearer ${token}` }, signal: controller.signal });
      if (response.status === 401) return { unauthorized: true };
      if (!response.ok) throw new Error('Unavailable');
      const value = await response.json();
      if (!value || typeof value !== 'object' || Array.isArray(value) || (list && !Array.isArray(value[list]))) throw new Error('Invalid response');
      return { key, value: list ? value[list] : value };
    } finally {
      clearTimeout(timeout);
    }
  }));
  const data = {}, errors = {};
  let unauthorized = false;
  results.forEach((result, index) => {
    if (result.status === 'rejected') errors[resources[index][0]] = true;
    else if (result.value.unauthorized) unauthorized = true;
    else data[result.value.key] = result.value.value;
  });
  return { data, errors, unauthorized };
}
